// extracted by mini-css-extract-plugin
export default {"input-label":"styles__input-label___lSERP","i":"styles__i___w65pS","checkbox":"styles__checkbox___PWoJE","inline":"styles__inline____oLff","centered":"styles__centered____zq33"};